<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Bundle Package</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Bundle Package</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link
                  class="btn btn-info"
                  :to="{ name: 'BundlePackageList' }"
                >
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="custom-list">
                <ul>
                  <li><strong>ID</strong> {{ value.id }}</li>

                  <li>
                    <strong>Bundle Title</strong> {{ value.bundle_title }}
                  </li>

                  <li><strong>Slug / URL</strong> {{ value.slug }}</li>

                  <li>
                    <strong>Course</strong>
                    <span
                      v-if="!_.isEmpty(value.courses)"
                      class="badge bg-success"
                      v-for="(val, index) in value.courses"
                    >
                      {{ pre.courses[val] }}
                    </span>
                  </li>

                  <li><strong>Summary</strong> {{ value.summary }}</li>

                  <li><strong>Description</strong> {{ value.description }}</li>

                  <li>
                    <strong>Category</strong>
                    <span v-if="!_.isNil(value.category_id)">{{
                      pre.category_id[value.category_id]
                    }}</span>
                  </li>

                  <li>
                    <strong>Is Published</strong> {{ value.is_published }}
                  </li>

                  <li>
                    <strong>Bundle Image Path</strong>
                    <img
                      v-bind:src="
                        API_ASSET_UPLOAD_URL + value.bundle_image_path
                      "
                      class="img-fluid img-thumbnail rounded"
                      style="width: 200px"
                    />
                  </li>

                  <li>
                    <strong>Bundle intro video path</strong>
                    <a
                      @click="downloadFile(value.bundle_intro_video_path)"
                      href="javascript:void(0)"
                      class="btn btn-info"
                      >Download</a
                    >
                  </li>

                  <li><strong>Keyword</strong> {{ value.keyword }}</li>

                  <li>
                    <strong>Tag</strong>
                    <span
                      v-if="!_.isEmpty(value.tag)"
                      class="badge bg-success"
                      v-for="(val, index) in value.tag"
                    >
                      {{ pre.tag[val] }}
                    </span>
                  </li>

                  <li><strong>View Count</strong> {{ value.view_count }}</li>

                  <li>
                    <strong>Course Duration(in Minute)</strong>
                    {{ value.course_duration }}
                  </li>

                  <li><strong>Is Featured</strong> {{ value.is_featured }}</li>

                  <li>
                    <strong>Display Order</strong> {{ value.display_order }}
                  </li>

                  <li><strong>Price</strong> {{ value.price }}</li>

                  <li>
                    <strong>Discount Price</strong> {{ value.discount_price }}
                  </li>

                  <li>
                    <strong>Commission Configuration Id</strong>
                    {{ value.commission_configuration_id }}
                  </li>

                  <li>
                    <strong>Commission Expire Date</strong>
                    {{ value.commission_expire_date }}
                  </li>

                  <li>
                    <strong>cbs_product_id</strong> {{ value.cbs_product_id }}
                  </li>

                  <li>
                    <strong>cbs_product_callback_raw</strong>
                    {{ value.cbs_product_callback_raw }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Bundle_package_features</h3>
            </div>
            <!-- /.card-header -->
            <div class="card-body table-responsive p-0">
              <table class="table table-hover text-nowrap">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Title</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(val, index) in value.bundle_package_features">
                    <td>{{ val.id }}</td>
                    <td>{{ val.title }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import { DepartmentsAPI } from "@/services/api";
import axios from "axios";
const fileDownload = require("js-file-download");
import { Notification } from "element-ui";

export default {
  name: "BundlePackageShow",
  metaInfo: {
    title: "BundlePackage | Dotlines",
  },
  data: () => ({
    value: {
      bundle_package_features: [],
    },
    pre: {
      courses: [],
      category_id: [],
      tag: [],
    },
    is_loading: false,
  }),
  mounted: function () {
    this.initialize();
  },
  methods: {
    coursesOptions: function () {
      return new Promise((resolve) => {
        axios
          .get("/get-dropdown-options/8")
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            console.log("error " + error);
            resolve(error);
          });
      });
    },
    categoryIdOptions: function () {
      return new Promise((resolve) => {
        axios
          .get("/get-dropdown-options/3")
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            console.log("error " + error);
            resolve(error);
          });
      });
    },
    tagOptions: function () {
      return new Promise((resolve) => {
        axios
          .get("/get-dropdown-options/5")
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            console.log("error " + error);
            resolve(error);
          });
      });
    },

    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      await this.coursesOptions().then((courses) => {
        this.pre.courses = courses;
      });
      await this.categoryIdOptions().then((category_id) => {
        this.pre.category_id = category_id;
      });
      await this.tagOptions().then((tag) => {
        this.pre.tag = tag;
      });

      await this.getDetail(this.params.id).then((response) => {
        this.value = response.data;
      });

      this.is_loading = false;
    },
    downloadFile: function (url) {
      this.is_loading = true;
      axios
        .get(this.API_ASSET_UPLOAD_URL + url, { responseType: "arraybuffer" })
        .then((response) => {
          fileDownload(response.data, url.replaceAll("/", "-"));
          Notification.success({
            title: "Download Completed",
            message: "Download completed successfully",
            type: "success",
          });
        })
        .catch((error) => {
          Notification.error({
            title: "Download Failed",
            message: "Failed to download",
            type: "error",
          });
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/bundle_packages/" + id;
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            console.log("error " + error);
            reject(error);
          })
          .finally(() => {});
      });
    },
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
};
</script>
